import { render, staticRenderFns } from "./PasswordModify.vue?vue&type=template&id=95062770"
import script from "./PasswordModify.vue?vue&type=script&lang=js"
export * from "./PasswordModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports